import { render, staticRenderFns } from "./Spa.vue?vue&type=template&id=a2f0eff4&lang=pug&"
import script from "./Spa.vue?vue&type=script&lang=ts&"
export * from "./Spa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports